
<template>
  <div>
    <data-list :payload="listPayloadObj" class="mt-3" :headers="headers"></data-list>
  </div>
</template>
<script>
export default {
  data () {
    return {
      total: 0,
      customerId: this.$route.params.crm_id || 0,
      listPayloadObj: {
        isHeader: true,
        isHideAdd: true,
        selection: [],
        showSelect: false,
        list: [],
        loading: false,
        editProp: 'ordernumber',
        editURL: (item) => `/orders/actions/${item.orderid}`
      },
      loading: false
    }
  },
  components: {
    DataList: () => import('@/components/DataList.vue')
  },
  computed: {
    headers () {
      return [{
        text: this.$t('message.stocks.orderNumber'),
        value: 'ordernumber'
      }, {
        text: this.$t('message.layout.product'),
        value: 'productname'
      }, {
        text: 'WIN',
        value: 'winnumber'
      }, {
        text: this.$t('message.order.startDate'),
        value: 'startdate'
      }, {
        text: this.$t('message.order.endDate'),
        value: 'enddate'
      }, {
        text: this.$t('message.stocks.delivery'),
        value: 'deliverydate'
      }, {
        text: this.$t('message.customer.status'),
        value: 'status_text'
      }]
    }
  },
  mounted () {
    this.getListHandler()
  },
  methods: {
    getListHandler () {
      this.listPayloadObj.loading = true
      this.$_executeApi('get', `orders/get_sale_products_by_customer/${this.customerId}`)
        .then((response) => {
          var data = response.data
          const transformList = {
            date: { list: ['startdate', 'enddate', 'deliverydate'], from: 'DD.MM.YYYYTH:mm:ss', to: 'DD.MM.YYYY' },
            status: [{ list: ['status'], value: '$_productionOrderStatus' }]
          }
          const model = this.$_formatListModel(data, transformList)
          model.forEach(element => {
            const status = this.$_productionOrderStatus.find(x => x.val === element.status)
            if (status) element.status_text = `${status.text}`
            else element.status_text = ''
          })
          this.listPayloadObj.list = model
        })
        .finally(() => {
          this.listPayloadObj.loading = false
        })
    }
  }
}
</script>
